import { ReactNode } from 'react';
import { AppLayout } from '../components/AppLayout';

const NewsLayout = ({ children }: { children: ReactNode }) => {
  return <AppLayout enableSiteTheme={false}>{children}</AppLayout>;
};

export default [NewsLayout];
